import React, { useState, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownTimeoutRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleDropdownEnter = (dropdownName) => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    setActiveDropdown(dropdownName);
  };

  const handleDropdownLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 150); // 150ms delay before closing
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={closeMenu}>
            <span className="text-2xl font-bold text-[#1A3A5F]">M7 CORP</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            <NavLink 
              to="/" 
              className={({ isActive }) => 
                isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700 hover:text-[#4D8BC9]"
              }
            >
              Home
            </NavLink>
            <div 
              className="relative"
              onMouseEnter={() => handleDropdownEnter('empresas')}
              onMouseLeave={handleDropdownLeave}
            >
              <button className="text-gray-700 hover:text-[#4D8BC9] flex items-center">
                Empresas
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-10 ${activeDropdown === 'empresas' ? 'block' : 'hidden'}`}>
                <NavLink 
                  to="/maintech" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  MAIN'TECH PLUS
                </NavLink>
                <NavLink 
                  to="/iadg" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  IADG EXPERTS
                </NavLink>
              </div>
            </div>
            <div 
              className="relative"
              onMouseEnter={() => handleDropdownEnter('servicos')}
              onMouseLeave={handleDropdownLeave}
            >
              <button className="text-gray-700 hover:text-[#4D8BC9] flex items-center">
                Serviços
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`absolute left-0 mt-2 w-64 bg-white rounded-md shadow-lg py-2 z-10 ${activeDropdown === 'servicos' ? 'block' : 'hidden'}`}>
                <NavLink 
                  to="/servicos" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Todos os Serviços
                </NavLink>
                <NavLink 
                  to="/servicos/inspecao" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Inspeção
                </NavLink>
                <NavLink 
                  to="/servicos/integridade" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Integridade
                </NavLink>
                <NavLink 
                  to="/servicos/ensaios" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Ensaios
                </NavLink>
                <NavLink 
                  to="/servicos/normativas" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Normativas
                </NavLink>
                <NavLink 
                  to="/servicos/calculo" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Cálculo
                </NavLink>
                <NavLink 
                  to="/servicos/manutencao" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Manutenção
                </NavLink>
                <NavLink 
                  to="/servicos/engenharia" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Engenharia
                </NavLink>
              </div>
            </div>
            <div 
              className="relative"
              onMouseEnter={() => handleDropdownEnter('recursos')}
              onMouseLeave={handleDropdownLeave}
            >
              <button className="text-gray-700 hover:text-[#4D8BC9] flex items-center">
                Recursos
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-10 ${activeDropdown === 'recursos' ? 'block' : 'hidden'}`}>
                <NavLink 
                  to="/cases" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Cases
                </NavLink>
                <NavLink 
                  to="/certificacoes" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Certificações
                </NavLink>
                <NavLink 
                  to="/blog" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Blog
                </NavLink>
                <NavLink 
                  to="/faq" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  FAQ
                </NavLink>
              </div>
            </div>
            <div 
              className="relative"
              onMouseEnter={() => handleDropdownEnter('normativas')}
              onMouseLeave={handleDropdownLeave}
            >
              <button className="text-gray-700 hover:text-[#4D8BC9] flex items-center">
                Normativas
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-10 ${activeDropdown === 'normativas' ? 'block' : 'hidden'}`}>
                <NavLink 
                  to="/normativas" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  Todas as Normativas
                </NavLink>
                <NavLink 
                  to="/normativas/nr13" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  NR-13
                </NavLink>
                <NavLink 
                  to="/normativas/nr11" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  NR-11
                </NavLink>
                <NavLink 
                  to="/normativas/nr20" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  NR-20
                </NavLink>
                <NavLink 
                  to="/normativas/nr33" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  NR-33
                </NavLink>
                <NavLink 
                  to="/normativas/nr35" 
                  className={({ isActive }) => 
                    isActive 
                      ? "block px-4 py-2 text-[#4D8BC9] font-bold" 
                      : "block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  }
                >
                  NR-35
                </NavLink>
              </div>
            </div>
            <NavLink 
              to="/sobre" 
              className={({ isActive }) => 
                isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700 hover:text-[#4D8BC9]"
              }
            >
              Sobre
            </NavLink>
            <NavLink 
              to="/contato" 
              className={({ isActive }) => 
                isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700 hover:text-[#4D8BC9]"
              }
            >
              Contato
            </NavLink>
          </nav>

          {/* Client Area Button */}
          <div className="hidden md:block">
            <Link 
              to="/cliente-area" 
              className="bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-2 px-4 rounded transition-colors"
            >
              Área do Cliente
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={toggleMenu}
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="container mx-auto px-4 py-4">
            <nav className="flex flex-col space-y-4">
              <NavLink 
                to="/" 
                className={({ isActive }) => 
                  isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700"
                }
                onClick={closeMenu}
              >
                Home
              </NavLink>
              
              {/* Mobile Empresas Dropdown */}
              <div className="space-y-2">
                <div className="font-medium text-gray-700">Empresas</div>
                <div className="pl-4 space-y-2">
                  <NavLink 
                    to="/maintech" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    MAIN'TECH PLUS
                  </NavLink>
                  <NavLink 
                    to="/iadg" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    IADG EXPERTS
                  </NavLink>
                </div>
              </div>
              
              {/* Mobile Serviços Dropdown */}
              <div className="space-y-2">
                <div className="font-medium text-gray-700">Serviços</div>
                <div className="pl-4 space-y-2">
                  <NavLink 
                    to="/servicos" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Todos os Serviços
                  </NavLink>
                  <NavLink 
                    to="/servicos/inspecao" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Inspeção
                  </NavLink>
                  <NavLink 
                    to="/servicos/integridade" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Integridade
                  </NavLink>
                  <NavLink 
                    to="/servicos/ensaios" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Ensaios
                  </NavLink>
                  <NavLink 
                    to="/servicos/normativas" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Normativas
                  </NavLink>
                  <NavLink 
                    to="/servicos/calculo" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Cálculo
                  </NavLink>
                  <NavLink 
                    to="/servicos/manutencao" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Manutenção
                  </NavLink>
                  <NavLink 
                    to="/servicos/engenharia" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Engenharia
                  </NavLink>
                </div>
              </div>
              
              {/* Mobile Recursos Dropdown */}
              <div className="space-y-2">
                <div className="font-medium text-gray-700">Recursos</div>
                <div className="pl-4 space-y-2">
                  <NavLink 
                    to="/cases" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Cases
                  </NavLink>
                  <NavLink 
                    to="/certificacoes" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Certificações
                  </NavLink>
                  <NavLink 
                    to="/blog" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Blog
                  </NavLink>
                  <NavLink 
                    to="/faq" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    FAQ
                  </NavLink>
                </div>
              </div>
              
              {/* Mobile Normativas Dropdown */}
              <div className="space-y-2">
                <div className="font-medium text-gray-700">Normativas</div>
                <div className="pl-4 space-y-2">
                  <NavLink 
                    to="/normativas" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    Todas as Normativas
                  </NavLink>
                  <NavLink 
                    to="/normativas/nr13" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    NR-13
                  </NavLink>
                  <NavLink 
                    to="/normativas/nr11" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    NR-11
                  </NavLink>
                  <NavLink 
                    to="/normativas/nr20" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    NR-20
                  </NavLink>
                  <NavLink 
                    to="/normativas/nr33" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    NR-33
                  </NavLink>
                  <NavLink 
                    to="/normativas/nr35" 
                    className={({ isActive }) => 
                      isActive ? "block text-[#4D8BC9] font-bold" : "block text-gray-700"
                    }
                    onClick={closeMenu}
                  >
                    NR-35
                  </NavLink>
                </div>
              </div>
              
              <NavLink 
                to="/sobre" 
                className={({ isActive }) => 
                  isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700"
                }
                onClick={closeMenu}
              >
                Sobre
              </NavLink>
              <NavLink 
                to="/contato" 
                className={({ isActive }) => 
                  isActive ? "text-[#4D8BC9] font-bold" : "text-gray-700"
                }
                onClick={closeMenu}
              >
                Contato
              </NavLink>
              
              {/* Mobile Client Area Button */}
              <Link 
                to="/cliente-area" 
                className="bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-2 px-4 rounded text-center transition-colors"
                onClick={closeMenu}
              >
                Área do Cliente
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
